import ExtraCampaignService from './ExtraCampaignService'

let instance

export default function ExtraCampaignsServiceProvider () {
  if (!instance) {
    instance = new ExtraCampaignService()
  }

  return instance
}



// WEBPACK FOOTER //
// ./src/api/extra-campaigns/ExtraCampaignsServiceProvider.js